<script lang="ts">
	import type { HTMLInputAttributes } from "svelte/elements";

	export let value: string | number | undefined | null = '';
	export let label = '';
	export let name = '';
	export let loading = false;
	export let pattern: string | undefined = undefined;   // for numbers only use pattern={0-9} in your component
	export let message: string | undefined = '';
	export let onInput: HTMLInputAttributes['on:input'] = (e) => {};
	export let onInputValidateByName = (name: string) => {}; // #reclaimoninput
	export let onChange: HTMLInputAttributes['on:change'] = (e) => {};
	export let onChangeValidateByName = (name: string) => {}; // #reclaimonchange
	export let onFocus: HTMLInputAttributes['on:focus'] = (e) => {};
	export let onBlur: HTMLInputAttributes['on:blur'] = (e) => {};
  export let validityClass: string = '';
	export let init: (element: HTMLInputElement) => void = () => {};

	const regex = new RegExp(`[^${pattern}]`);

  const mask = () => {
    if (pattern) {
			if (typeof value === 'string') value = value?.replace(regex, '');
			if (typeof value === 'number') value = +(value.toString().replace(regex, ''));
		}
  }

	const _onInput: HTMLInputAttributes['on:input'] = (e) => {
    onInput?.(e);
		onInputValidateByName(name);
		if (!value || validityClass.includes('error') || validityClass.includes('success')) {
			// onChange?.(e); // only needed for change
			onChangeValidateByName(name);
		}
    mask();
  }

	const _onChange: HTMLInputAttributes['on:change'] = (e) => {
		onChange?.(e);
		onChangeValidateByName(name);
	}
</script>

<label class="label-xl book {validityClass}" class:load={loading || validityClass.indexOf('pending') > -1}>
	<input type="text" bind:value placeholder=" " {...$$props} on:change={_onChange} on:input={_onInput} on:focus={onFocus} on:blur={onBlur} use:init pattern={pattern ? `[${pattern}]*` : undefined} />
	<!-- {#if message && !messageIsLong}<i>&nbsp;&#183; {message}</i>{/if} -->
	<span>{label}</span>
	{#if loading || validityClass.indexOf('pending') > -1}
		<span class="spinner"></span>
	{:else}
		<slot />
	{/if}
	{#if message}
		<p class="label-xs medium">{message}</p>
	{/if}
</label>

<style lang="scss">
  @use 'component/input';
</style>